import React, { useEffect, useState } from "react";
import { Button, Card, Col, Drawer, Empty, Modal, Row, Spin } from "antd";
import { FileOutlined, FilePdfOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { URL_MATERIALES_POR_CAMPANIA } from "../../../../constants/url";
import { get } from "../../../../utils/fetch";

export const InformacionCampaniaDrawer = ({ campaniaID }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [materiales, setMateriales] = useState([]);
  const [materialSeleccionado, setMaterialSeleccionado] = useState(null);

  useEffect(() => {
    const loadMateriales = async () => {
      setMateriales([]);
      setOpen(false);
      setMaterialSeleccionado(null);

      if (!campaniaID) return;

      setLoading(true);
      try {
        const result = await get(`${URL_MATERIALES_POR_CAMPANIA}/${campaniaID}`);
        setMateriales(result.code === 0 && Array.isArray(result.data) ? result.data : []);
      } finally {
        setLoading(false);
      }
    };

    loadMateriales();
  }, [campaniaID]);

  const tieneImagenes = materiales.some((material) => esImagen(material.url));

  if (!tieneImagenes) return null;

  return (
    <>
      <Card size="small">
        <div className="crear-servicios-v2__section-header">
          <div className="crear-servicios-v2__section-header-title">
            <InfoCircleOutlined />
            <span>Información</span>
          </div>
        </div>
        <Button type="link" size="small" onClick={() => setOpen(true)}>
          Ver información importante de la campaña
        </Button>
      </Card>
      <Drawer
        title="Información"
        placement="right"
        onClose={() => setOpen(false)}
        visible={open}
        bodyStyle={{ overflowY: "auto" }}
        width={620}
      >
        {loading ? (
          <div style={{ marginTop: 40, textAlign: "center" }}>
            <Spin />
          </div>
        ) : materiales.length === 0 ? (
          <Empty description="Sin materiales" />
        ) : (
          <Row gutter={[12, 12]}>
            {materiales.map((material) => {
              const url = material.url;

              return (
                <Col span={24} key={material.id || material.url}>
                  <Card
                    hoverable
                    onClick={() => setMaterialSeleccionado(material)}
                    size="small"
                    cover={
                      <div
                        style={{
                          alignItems: "center",
                          display: "flex",
                          height: 500,
                          justifyContent: "center",
                          overflow: "hidden",
                        }}
                      >
                        {esImagen(url) ? (
                          <img
                            alt={material.descripcion}
                            src={url}
                            style={{
                              height: "100%",
                              objectFit: "cover",
                              width: "100%",
                            }}
                          />
                        ) : esPdf(url) ? (
                          <FilePdfOutlined style={{ color: "#ca2228", fontSize: 38 }} />
                        ) : (
                          <FileOutlined style={{ fontSize: 38 }} />
                        )}
                      </div>
                    }
                    style={{ height: "100%" }}
                  >
                    <Card.Meta
                      title={material.descripcion}
                    />
                  </Card>
                </Col>
              );
            })}
          </Row>
        )}
      </Drawer>
      <Modal
        footer={null}
        onCancel={() => setMaterialSeleccionado(null)}
        title={materialSeleccionado?.descripcion}
        visible={!!materialSeleccionado}
        width="80%"
      >
        {materialSeleccionado && esImagen(materialSeleccionado.url) ? (
          <img
            alt={materialSeleccionado.descripcion}
            src={materialSeleccionado.url}
            style={{ maxHeight: "75vh", objectFit: "contain", width: "100%" }}
          />
        ) : materialSeleccionado ? (
          <iframe
            src={getPdfViewerUrl(materialSeleccionado.url)}
            style={{ border: 0, height: "75vh", width: "100%" }}
            title={materialSeleccionado.descripcion}
          />
        ) : null}
      </Modal>
    </>
  );
};

const esImagen = (url) => /\.(jpg|jpeg|png|gif|webp)$/i.test(url || "");
const esPdf = (url) => /\.pdf$/i.test(url || "");
const getPdfViewerUrl = (url) =>
  `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(url)}`;
